import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1386.667 160.0034C1386.667 71.7904 1314.88.0034 1226.667.0034L160 .0034C71.787.0034 0 71.7904 0 160.0034L0 320.0034 1386.667 320.0034 1386.667 160.0034zM1904.373 762.2963L1584.373 442.2963 1508.96 517.7103 1737.867 746.7233 1386.613 746.7233 1386.613 853.3363 853.333 853.3363 853.333 746.6703 1386.667 746.6703 1386.667 426.6703 0 426.6703 0 1226.6703C0 1315.2033 71.467 1386.6703 160 1386.6703L1226.667 1386.6703C1315.2 1386.6703 1386.667 1315.2033 1386.667 1226.6703L1386.667 853.3903 1737.867 853.3903 1508.96 1082.2963 1584.373 1157.7103 1904.373 837.7103C1925.173 816.9093 1925.173 783.0973 1904.373 762.2963",
  transform: "translate(0 266)"
}));

var IconExternalLinkSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconExternalLinkSolid, _Component);

  var _super = _createSuper(IconExternalLinkSolid);

  function IconExternalLinkSolid() {
    _classCallCheck(this, IconExternalLinkSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconExternalLinkSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExternalLink",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconExternalLinkSolid.displayName = "IconExternalLinkSolid";
  return IconExternalLinkSolid;
}(Component);

IconExternalLinkSolid.glyphName = 'external-link';
IconExternalLinkSolid.variant = 'Solid';
IconExternalLinkSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExternalLinkSolid;
export { IconExternalLinkSolid };